// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tympole: PokeData = {
  "id": 535,
  "name": "tympole",
  "height": 5,
  "weight": 45,
  "base_experience": 59,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "growl",
    "supersonic",
    "acid",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "flail",
    "rain-dance",
    "uproar",
    "hyper-voice",
    "muddy-water",
    "mud-shot",
    "aqua-ring",
    "round",
    "echoed-voice"
  ],
  "moves": [
    "growl",
    "supersonic",
    "acid",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "rain-dance",
    "hyper-voice",
    "mud-shot",
    "aqua-tail",
    "life-dew",
    "brine",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 273,
    "item": null,
    "species": [
      {
        "name": "tympole",
        "order": 536,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "palpitoad",
        "order": 537,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 535,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "seismitoad",
        "order": 538,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 536,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 64,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
